<template>
    <div>
        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <h3 class="fg-color-blue">Sign-in with SSO</h3>
            <br />

            <div v-if="!completedRequestSsoUrlCommandV1">
                <div class="form-group">
                    <label>Email:</label>
                    <input v-model="email" type="email" class="form-control" placeholder="Email address">
                    <ValidationError context="Email" :errors="validationErrors"></ValidationError>
                </div>

                <button v-if="!invokingRequestSsoUrlCommandV1" @click="invokeRequestSsoUrlCommandV1" class="btn btn-lg btn-primary btn-block">Sign-in</button>
                <button v-else class="btn btn-lg btn-primary btn-block" disabled>Signing-in...</button>
                <br />

                <!--<span>
                    <span>Don't have an account?</span>
                    <a href="/#/organizations/users/requestaccount">Request access</a>
                </span>-->
            </div>

            <div v-else>
                <p>
                    To complete sign-in please check your mailbox. We have sent you link to sign-in to TransparentChoice via your organizational account.
                    If you didn't receive anything please ensure that your account is valid and your organization has enabled SSO or just try again.
                </p>
            </div>

            <hr /><br />
            <a href="/#/organizations/users/signin" class="btn btn-secondary btn-lg btn-block">Sign-in with password</a>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed, onMounted } from 'vue'
    import ValidationError from '@common/Components/ValidationError.vue'
    import { useRequestSsoUrlCommandV1 } from '@Organizations/Users/commands-vue-composables'

    const email = ref('')

    const {
        invokeRequestSsoUrlCommandV1,
        invokingRequestSsoUrlCommandV1,
        succeedRequestSsoUrlCommandV1,
        validationErrors,
        errorRequestSsoUrlCommandV1,
        completedRequestSsoUrlCommandV1
    } = useRequestSsoUrlCommandV1(email)

    onMounted(() =>
    {
        document.title = 'Sign in with SSO to TransparentChoice'
    })
</script>
